export const privileges = {
  computed: {
    isSuperAdmin() {
      return localStorage.privIsSuperAdmin == "true";
    },
    isAdminOrSuperAdmin() {
      return localStorage.privIsAdmin  == "true"|| localStorage.privIsSuperAdmin == "true";
    }
  }
}
